import styled from 'styled-components';
import { background, color, compose, flexbox, grid, layout, position, space, textAlign } from 'styled-system';
import { theme } from '../../essentials/theme';
const Box = styled.div.attrs({ theme }).withConfig({ displayName: "Box", componentId: "sc-lqdr92" }) `
    ${compose(space, layout, position, color, flexbox, grid, background, textAlign)}
`;
export { Box };
